import { IPasswordStrengthIndicatorViewProps } from "./PasswordStrengthIndicator";
import { ValidationEntry } from "./ValidationEntry";

export const View = (props: IPasswordStrengthIndicatorViewProps) => {
  const {
    touched,
    minimumLength,
    maximumLength,
    validateLowerCase,
    validateUpperCase,
    validateDigitPresent,
    validateSpecialCharacter,

    hideIndicator,
    isMinLengthValid,
    isMaxLengthValid,
    isLowerCaseValid,
    isUpperCaseValid,
    isDigitPresentValid,
    isSpecialCharacterValid,
  } = props;

  // if (!touched || hideIndicator) return null;

  return (
    <div
      className={`password-strength-indicator--container ${
        !touched || hideIndicator ? "hidden" : "shown"
      }`}
    >
      <ul className="">
        {!minimumLength ? null : (
          <ValidationEntry
            isValid={isMinLengthValid}
            description={`${minimumLength} characters minimum`}
          />
        )}
        {!maximumLength ? null : (
          <ValidationEntry
            isValid={isMaxLengthValid}
            description={`${maximumLength} characters minimum`}
          />
        )}
        {!validateLowerCase ? null : (
          <ValidationEntry
            isValid={isLowerCaseValid}
            description={"One lowercase letter"}
          />
        )}
        {!validateUpperCase ? null : (
          <ValidationEntry
            isValid={isUpperCaseValid}
            description={"One uppercase letter"}
          />
        )}
        {!validateDigitPresent ? null : (
          <ValidationEntry
            isValid={isDigitPresentValid}
            description={"One number"}
          />
        )}
        {!validateSpecialCharacter ? null : (
          <ValidationEntry
            isValid={isSpecialCharacterValid}
            description={`One special character eg !@#$%^&*()\-_"=+{};`}
          />
        )}
        {/* {!xxxx ? null : <ValidationIndicatorBadge isValid={isxxxxxxxxxValid} description={"xxxxxxxx"} />} */}
      </ul>
    </div>
  );
};
